import {
  IconNetwork,
  IconMail,
  IconBrain,
  IconFileText,
  IconRepeat,
  IconBrandGoogleDrive,
  IconGitBranch,
  IconDatabase,
  IconPlus,
  IconEdit,
  IconSwitchHorizontal,
  IconClock,
  IconFilter,
} from "@tabler/icons";
import LoopNode from "./nodes/loopNode";

const NODE_TYPES = [
  {
    type: "TRIGGER",
    label: "Workflow Trigger",
    icon: IconNetwork,
    description: "Trigger workflow",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Start",
      },
      {
        name: "type",
        label: "Trigger Type",
        type: "select",
        options: ["MANUAL", "SCHEDULE"],
      },
      {
        name: "schedule",
        label: "Schedule",
        type: "text",
        placeholder: "0 0 * * *",
        showOnlyIf: (node) => node.data.type === "SCHEDULE",
      },
    ],
    data: {
      type: "MANUAL", //MANUAL, SCHEDULE
      schedule: "0 0 * * *", // Default to daily at midnight
    },
  },
  {
    type: "GET_EMAIL",
    label: "Get Email",
    icon: IconMail,
    description: "Get email list from email server.",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Get Email",
      },
      {
        name: "credential",
        label: "Credential",
        type: "credentialSelect",
      },

      // {
      //   name: "email",
      //   label: "Email",
      //   type: "text",
      //   placeholder: "Email",
      // },
      // {
      //   name: "password",
      //   label: "Password",
      //   type: "text",
      //   placeholder: "Password",
      // },
      // {
      //   name: "host",
      //   label: "Host",
      //   type: "text",
      //   placeholder: "Host",
      // },
      // {
      //   name: "port",
      //   label: "Port",
      //   type: "text",
      //   placeholder: "Port",
      // },
      {
        name: "action",
        label: "Action",
        type: "select",
        defaultValue: "NOTHING",
        options: ["NOTHING", "MARK SEEN"],
      },

      {
        name: "searchCriteria",
        label: "Search Criteria",
        type: "fieldList",
        options: [
          {
            field: "FROM",
            fieldType: "text",
            defaultValue: "",
          },
          {
            field: "SUBJECT",
            fieldType: "text",
            defaultValue: "",
          },
          {
            field: "WITHINDAYS",
            fieldType: "number",
            defaultValue: 10,
          },
          {
            field: "UNSEEN",
            fieldType: "checkbox",
            defaultValue: true,
          },
        ],
        defaultValue: [],
      },
    ],
    data: {
      // host: "imap.gmail.com",
      // port: "993",
      // email: "",
      // password: "",
      action: "NOTHING",
      searchCriteria: [],
      credential: null,
    },
  },
  {
    type: "READ_EMAIL",
    label: "Read Email",
    icon: IconMail,
    description: "Read email from email server.",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "credential",
        label: "Credential",
        type: "credentialSelect",
      },
      {
        field: "downloadAttachment",
        label: "Download Attachment",
        type: "checkbox",
        defaultValue: true,
      },
      {
        name: "markSeen",
        label: "Mark Seen",
        type: "checkbox",
        defaultValue: false,
      },
    ],
    data: {
      downloadAttachment: true,
      markSeen: false,
      credential: null,
    },
  },
  {
    type: "AI_EXTRACT",
    label: "AI Extract",
    icon: IconBrain,
    description: "Extract data from text using AI",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "AI Extract",
      },
      {
        name: "credential",
        label: "Credential",
        type: "credentialSelect",
      },
      {
        name: "prompt",
        label: "AI Prompt",
        type: "textarea",
        placeholder: "Enter the prompt for AI extraction",
      },
      {
        name: "inputField",
        label: "Input Field",
        type: "text",
        placeholder: "Field name containing text to analyze",
      },
      {
        name: "outputField",
        label: "Output Field",
        type: "text",
        placeholder: "Field name to store the output",
      },
      {
        name: "outputFormat",
        label: "Output Format",
        type: "select",
        options: ["JSON", "TEXT"],
        defaultValue: "JSON",
      },
    ],
    data: {
      prompt: "",
      inputField: "",
      outputFormat: "JSON",
    },
  },
  {
    type: "OCR",
    label: "OCR Processing",
    icon: IconFileText,
    description: "Extract text from images or PDFs using OCR",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "OCR Processing",
      },

      {
        name: "inputField",
        label: "Input Field",
        type: "text",
        placeholder: "Field name containing file to process",
      },
      {
        name: "language",
        label: "Language",
        type: "select",
        options: ["eng", "chi_sim", "chi_tra"],
        defaultValue: "eng",
      },
    ],
    data: {
      inputType: "PDF",
      inputField: "",
      language: "eng",
    },
  },
  {
    type: "FILTER",
    label: "Filter Array",
    icon: IconFilter,
    description:
      "Filter an array based on conditions and output to a new field",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Filter Array",
      },
      {
        name: "inputArray",
        label: "Input Array",
        type: "text",
        placeholder: "Field name containing array to filter",
      },
      {
        name: "newFieldName",
        label: "Output Field Name",
        type: "text",
        placeholder: "Name for filtered array output",
        defaultValue: "filteredArray",
      },
      {
        name: "filterFunction",
        label: "Filter Function",
        type: "textarea",
        placeholder: "(item) => { return true }",
        defaultValue: "",
      },
    ],
    data: {
      inputArray: "",
      newFieldName: "filteredArray",
      filterCriteria: [],
    },
  },
  {
    type: "LOOP",
    label: "Loop",
    icon: IconRepeat,
    description: "Loop through elements in an array",
    targetPosition: "left",
    sourcePosition: ["right", "bottom"],
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Loop",
      },
      {
        name: "inputArray",
        label: "Input Array",
        type: "text",
        placeholder: "Field name containing array to loop through",
      },
      {
        name: "itemName",
        label: "Item Name",
        type: "text",
        placeholder: "Name for current item in loop",
        defaultValue: "item",
      },
      {
        name: "indexName",
        label: "Index Name",
        type: "text",
        placeholder: "Name for current index in loop",
        defaultValue: "index",
      },
    ],
    data: {
      inputArray: "",
      itemName: "item",
      indexName: "index",
    },
  },
  {
    type: "GOOGLE_DRIVE",
    label: "Google Drive",
    icon: IconBrandGoogleDrive,
    description: "Interact with Google Drive files and folders",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Google Drive",
      },
      {
        name: "credential",
        label: "Credential",
        type: "credentialSelect",
      },
      {
        name: "action",
        label: "Action",
        type: "select",
        options: ["LIST_FILES", "DOWNLOAD", "UPLOAD", "CREATE_FOLDER"],
        defaultValue: "LIST_FILES",
      },
      {
        name: "folderId",
        label: "Folder ID",
        type: "text",
        placeholder: "Google Drive folder ID",
        showOnlyIf: (node) =>
          ["LIST_FILES", "UPLOAD", "CREATE_FOLDER"].includes(node.data.action),
      },
      {
        name: "fileName",
        label: "File Name",
        type: "text",
        placeholder: "Name for new file/folder",
        showOnlyIf: (node) =>
          ["UPLOAD", "CREATE_FOLDER"].includes(node.data.action),
      },
      {
        name: "fileContent",
        label: "File Content",
        type: "text",
        placeholder: "Field name containing file content",
        showOnlyIf: (node) => node.data.action === "UPLOAD",
      },
    ],
    data: {
      action: "LIST_FILES",
      folderId: "",
      fileName: "",
      fileContent: "",
    },
  },
  {
    type: "IF",
    label: "Condition",
    icon: IconGitBranch,
    description: "Conditional branching in workflow",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Condition",
      },
      {
        name: "condition",
        label: "Condition",
        type: "select",
        options: [
          "EQUALS",
          "NOT_EQUALS",
          "CONTAINS",
          "GREATER_THAN",
          "LESS_THAN",
          "EXISTS",
          "NOT_EXISTS",
        ],
        defaultValue: "EQUALS",
      },
      {
        name: "leftOperand",
        label: "Left Operand",
        type: "text",
        placeholder: "Field name or value",
      },
      {
        name: "rightOperand",
        label: "Right Operand",
        type: "text",
        placeholder: "Field name or value",
        showOnlyIf: (node) =>
          !["EXISTS", "NOT_EXISTS"].includes(node.data.condition),
      },
    ],
    data: {
      condition: "EQUALS",
      leftOperand: "",
      rightOperand: "",
    },
  },
  {
    type: "SEARCH_DB",
    label: "Search Database",
    icon: IconDatabase,
    description: "Search records in database",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Search Database",
      },
      {
        name: "model",
        label: "Model",
        type: "select",
        options: [
          "Client",
          "Quotation",
          "DebitNote",
          "Provider",
          "ProductType",
        ],
        defaultValue: "Client",
      },
      {
        name: "query",
        label: "Query",
        type: "fieldList",
        options: [
          {
            field: "field",
            fieldType: "text",
            defaultValue: "",
          },
          {
            field: "operator",
            fieldType: "select",
            defaultValue: "equals",
            options: ["equals", "contains", "greaterThan", "lessThan"],
          },
          {
            field: "value",
            fieldType: "text",
            defaultValue: "",
          },
        ],
        defaultValue: [],
      },
      {
        name: "limit",
        label: "Limit",
        type: "number",
        defaultValue: 10,
      },
    ],
    data: {
      model: "Client",
      query: [],
      limit: 10,
    },
  },
  {
    type: "CREATE_DB_RECORD",
    label: "Create Record",
    icon: IconPlus,
    description: "Create new record in database",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Create Record",
      },
      {
        name: "model",
        label: "Model",
        type: "select",
        options: [
          "Client",
          "Quotation",
          "DebitNote",
          "Provider",
          "ProductType",
        ],
        defaultValue: "Client",
      },
      {
        name: "fields",
        label: "Fields",
        type: "fieldList",
        options: [
          {
            field: "name",
            fieldType: "text",
            defaultValue: "",
          },
          {
            field: "value",
            fieldType: "text",
            defaultValue: "",
          },
        ],
        defaultValue: [],
      },
    ],
    data: {
      model: "Client",
      fields: [],
    },
  },
  {
    type: "UPDATE_DB_RECORD",
    label: "Update Record",
    icon: IconEdit,
    description: "Update existing record in database",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Update Record",
      },
      {
        name: "model",
        label: "Model",
        type: "select",
        options: [
          "Client",
          "Quotation",
          "DebitNote",
          "Provider",
          "ProductType",
        ],
        defaultValue: "Client",
      },
      {
        name: "recordId",
        label: "Record ID",
        type: "text",
        placeholder: "Field name containing record ID",
      },
      {
        name: "fields",
        label: "Fields",
        type: "fieldList",
        options: [
          {
            field: "name",
            fieldType: "text",
            defaultValue: "",
          },
          {
            field: "value",
            fieldType: "text",
            defaultValue: "",
          },
        ],
        defaultValue: [],
      },
    ],
    data: {
      model: "Client",
      recordId: "",
      fields: [],
    },
  },
  {
    type: "WAIT",
    label: "Wait",
    icon: IconClock,
    description: "Wait for a specified amount of time",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      // wait how many seconds
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Wait",
      },
      {
        name: "waitTime",
        label: "Wait Time",
        type: "number",
        placeholder: "2",
      },
    ],
    data: {
      waitTime: 2,
      label: "Wait",
    },
  },
  {
    type: "SWITCH_CASE",
    label: "Switch Case",
    icon: IconSwitchHorizontal,
    description: "Handle multiple conditions with different outcomes",
    targetPosition: "left",
    sourcePosition: "right",
    fields: [
      {
        name: "label",
        label: "Label",
        type: "text",
        placeholder: "Switch Case",
      },
      {
        name: "switchField",
        label: "Switch Field",
        type: "text",
        placeholder: "Field name to evaluate",
      },
      {
        name: "cases",
        label: "Cases",
        type: "fieldList",
        options: [
          {
            field: "value",
            fieldType: "text",
            defaultValue: "",
            label: "Case Value",
          },
          {
            field: "label",
            fieldType: "text",
            defaultValue: "",
            label: "Case Label",
          },
        ],
        defaultValue: [],
      },
      {
        name: "defaultCase",
        label: "Default Case",
        type: "text",
        placeholder: "Label for default case",
      },
    ],
    data: {
      switchField: "",
      cases: [],
      defaultCase: "",
    },
  },
];

export default NODE_TYPES;
